import Api from "~/service/Api";

class MediaItemRepository {
  fetch(query) {
    return Api.get(`/media-items`, query);
  }

  create(tourId, data) {
    return Api.put(`/media-items/${tourId}`, data);
  }

  update(className, id, data) {
    return Api.put(`/media-items/${className}/${id}`, data);
  }
}

export default MediaItemRepository;
